import * as c from "react";
import { useThemeWithoutDefault as p, getThemeProps as h } from "@mui/system";
import v from "./useEnhancedEffect.mjs";
function S(t, u, e, o, i) {
  const [r, f] = c.useState(() => i && e ? e(t).matches : o ? o(t).matches : u);
  return v(() => {
    let a = !0;
    if (!e)
      return;
    const n = e(t), l = () => {
      a && f(n.matches);
    };
    return l(), n.addListener(l), () => {
      a = !1, n.removeListener(l);
    };
  }, [t, e]), r;
}
const d = c.useSyncExternalStore;
function w(t, u, e, o, i) {
  const r = c.useCallback(() => u, [u]), f = c.useMemo(() => {
    if (i && e)
      return () => e(t).matches;
    if (o !== null) {
      const {
        matches: s
      } = o(t);
      return () => s;
    }
    return r;
  }, [r, t, o, i, e]), [a, n] = c.useMemo(() => {
    if (e === null)
      return [r, () => () => {
      }];
    const s = e(t);
    return [() => s.matches, (m) => (s.addListener(m), () => {
      s.removeListener(m);
    })];
  }, [r, e, t]);
  return d(n, a, f);
}
function Q(t, u = {}) {
  const e = p(), o = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: i = !1,
    matchMedia: r = o ? window.matchMedia : null,
    ssrMatchMedia: f = null,
    noSsr: a = !1
  } = h({
    name: "MuiUseMediaQuery",
    props: u,
    theme: e
  });
  process.env.NODE_ENV !== "production" && typeof t == "function" && e === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let n = typeof t == "function" ? t(e) : t;
  n = n.replace(/^@media( ?)/m, "");
  const s = (d !== void 0 ? w : S)(n, i, r, f, a);
  return process.env.NODE_ENV !== "production" && c.useDebugValue({
    query: n,
    match: s
  }), s;
}
export {
  Q as default
};
//# sourceMappingURL=useMediaQuery.mjs.map
